var bookshelf = require("../index-extended"); // ???: ..
require("./Licence");

module.exports = bookshelf.model("Agency", {
  tableName: "agency",
  licences() {
    return this.hasMany("Licence", "agency_id");
  },
});
